<template>
    <div>
        <page-header-filters>
            <template #leftFilters>
                <space-switch @change="handleSpaceChange" />
            </template>
            <template #rightFilters>
                <reset-filters-button :active="isResetActive" />
                <date-range-picker v-model="dateFilter" @filterDefaultChange="handleFilterDefaultChange('datepicker', $event)" ga-page="Raport Rozkładu cen" />
            </template>
        </page-header-filters>
        <no-access-placeholder
            v-if="!hasPermission && !spacesLoading"
            :permission-name="permissionName"
            :title="$t('permissionContent.title.reportsPriceDistribution')"
            :description="$t('permissionContent.description.reportsPriceDistribution')"
            :image="require('../../assets/noAccessPlaceholders/reports-price-distribution.jpg')"
            cta-position="top"
            @activated="getData"
        />
        <v-card v-if="hasPermission" class="elevation-0 mb-4">
            <v-card-text>
                <div v-if="loading" class="text-xs-center">
                    <v-progress-circular indeterminate color="primary" />
                </div>

                <v-alert
                    :value="error"
                    dismissible
                    type="error"
                    transition="scale-transition">
                    {{error}}
                </v-alert>

                <data-placeholder v-if="!loading && !spaceId" :title="$t('producerReportsPriceDistribution.noSpace')" />

                <div v-if="showPanel">
                    <price-distribution-section
                        ref="priceDistribution"
                        :dateFilter="dateFilter"
                    />

                    <price-deviations
                        ref="priceDeviations"
                        :dateFilter="dateFilter"
                    />
                </div>
            </v-card-text>
        </v-card>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import PageHeaderFilters from '@/components/common/PageHeaderFilters.vue';
import SpaceSwitch from '@/components/common/SpaceSwitch.vue';
import DateRangePicker from '@/components/common/DateRangePicker.vue';
import DataPlaceholder from '@/components/common/DataPlaceholder.vue';
import ResetFiltersButton from '@/components/common/ResetFiltersButton.vue';
import spaceService from '@/services/spaceService';
import permissionMixin from '@/mixins/permissionMixin';
import NoAccessPlaceholder from '@/components/common/NoAccessPlaceholder.vue';
import PriceDistributionSection from '@/components/producer/reports/priceDistribution/PriceDistributionSection.vue';
import PriceDeviations from '@/components/producer/reports/priceDistribution/PriceDeviations.vue';

export default {
    name: 'producer-reports-price-distribution',
    components: {
        PriceDistributionSection,
        PriceDeviations,
        NoAccessPlaceholder,
        ResetFiltersButton,
        DataPlaceholder,
        DateRangePicker,
        SpaceSwitch,
        PageHeaderFilters,
    },
    mixins: [
        permissionMixin,
    ],
    data() {
        return {
            permissionName: spaceService.permissions.STATS_PRICE_DISTRIBUTION,
            spaceInitialized: false,
            loadingConfig: false,
            error: null,
            dateFilter: {
                startDate: null,
                endDate: null,
                compareStartDate: null,
                compareEndDate: null,
            },
            isDatepickerLoading: false,
            isDatepickerFilterDefault: true,
            isPriceDistributionFilterDefault: false,
            isPriceDeviationsFilterDefault: false,
        };
    },
    computed: {
        showPanel() {
            return !this.loading && this.spaceId;
        },
        loading() {
            return !this.spaceInitialized || this.loadingConfig;
        },
        isResetActive() {
            return !this.isDatepickerFilterDefault || !this.isPriceDistributionFilterDefault || !this.isPriceDeviationsFilterDefault;
        },
        ...mapState({
            spacesLoading: state => state.space.loading.fetchSpaces,
            spaceId: state => state.space.currentSpaceId,
        }),
    },
    methods: {
        handleFilterDefaultChange(type, isDefault) {
            if (type === 'datepicker') {
                this.isDatepickerFilterDefault = isDefault;
            } else if (type === 'priceDistribution') {
                this.isPriceDistributionFilterDefault = isDefault;
            } else if (type === 'priceDeviations') {
                this.isPriceDeviationsFilterDefault = isDefault;
            }
        },
        async getCategories() {
            this.checkPermission(this.permissionName);
            if (!this.hasPermission) {
                return;
            }
            try {
                await this.fetchProducerProductCategories();
            } catch (e) {
                this.error = e.message;
            }
        },
        async getCampaigns() {
            this.checkPermission(this.permissionName);
            if (!this.hasPermission) {
                return;
            }
            try {
                this.error = null;
                await this.fetchPlugins();
                await this.fetchActiveCampaigns();
                await this.fetchAvailableCampaigns();
            } catch (e) {
                this.error = e.message;
            }
        },
        async getGroups() {
            this.checkPermission(this.permissionName);
            if (!this.hasPermission) {
                return;
            }
            try {
                this.error = null;
                await this.fetchGroups();
            } catch (e) {
                this.error = e.message;
            }
        },
        handleSpaceChange() {
            this.getData();

            if (!this.spaceInitialized) {
                this.spaceInitialized = true;
            }
        },
        async getData() {
            this.checkPermission(this.permissionName);
            if (!this.hasPermission) {
                return;
            }
            this.loadingConfig = true;
            await this.getCategories();
            await this.getCampaigns();
            await this.getGroups();
            this.loadingConfig = false;
        },
        ...mapActions({
            fetchProducerProductCategories: 'space/fetchProducerProductCategories',
            fetchPlugins: 'plugin/fetchPlugins',
            fetchActiveCampaigns: 'plugin/fetchActiveCampaigns',
            fetchAvailableCampaigns: 'plugin/fetchAvailableCampaigns',
            fetchProductDetails: 'products/fetchProductDetails',
            fetchGroups: 'producerProductGroup/fetchGroups',
        }),
    },
};
</script>

<style lang="scss">
</style>
